import { makeStyles } from "@material-ui/core/styles";
import { MenuItem, Select } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";

import { setMarketplace } from "../../../../../redux/slices/store_analytics";
import { MARKETPLACE_FLAGS } from "../../marketplaces";

export default function MarketPicker({
  value,
  onMarketSelected,
  style = {},
  disabled = false,
  marketplaces = ["us", "ca"],
}) {
  const dispatch = useDispatch();
  const markets = marketplaces.map((code) => ({
    label: MARKETPLACE_FLAGS[code] ?? code.toUpperCase(),
    value: code,
  }));
  const useStyles = makeStyles({
    selectMarketStyle: {
      borderRadius: "10px",
      height: "40px",
      fontWeight: "bold",
      margin: "4px",
      "& fieldset": {
        borderWidth: "2px",
      },
    },
    customStyle: style,
    selectedMenuItem: {
      backgroundColor: "#ffffff !important",
    },
  });

  const classes = useStyles();

  const handleMarketChange = (event) => {
    const name = markets.filter((x) => x.value === event.target.value)[0]
      ?.value;
    if (!name) return;
    onMarketSelected(name);
    dispatch(setMarketplace(name));
  };

  const fallback = marketplaces.includes("us") ? "us" : marketplaces[0] ?? "";
  const effectiveValue =
    value && markets.some((m) => m.value === value) ? value : fallback;

  return (
    <Select
      className={`${classes.selectMarketStyle} ${classes.customStyle}`}
      labelId="market-to-select-label"
      id="market-to-select"
      value={effectiveValue}
      onChange={handleMarketChange}
      disabled={disabled}
      MenuProps={{
        PaperProps: {
          sx: {
            "& .MuiMenuItem-root.Mui-selected": {
              backgroundColor: "rgba(55,111,208,0.08) !important",
            },
            "& .MuiMenuItem-root:hover": {
              backgroundColor: "rgba(0,0,0,0.04) !important",
            },
          },
        },
      }}
    >
      {markets.map((option, index) => (
        <MenuItem
          key={`${option.value} + ${index}`}
          value={option.value}
          className={classes.selectedMenuItem}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
}
